// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__u9aH1","list":"styles_list__3NhH5"};